import Badge from './Badge';
import type {ProfileSummary} from '../types/steam';

interface BanStatusDisplayProps {
    summary: ProfileSummary;
}

function BanStatusDisplay({summary}: BanStatusDisplayProps) {
    if (!summary.vacBanned && summary.gameBans === 0) {
        return <Badge variant="no-ban">No Bans</Badge>;
    }

    const badges = [];
    if (summary.gameBans > 0) {
        badges.push(
            <Badge key="game" variant="game">
                {summary.gameBans > 1 ? `${summary.gameBans} Game Bans` : 'Game Ban'}
            </Badge>
        );
    }
    if (summary.vacBanned) {
        let banText =
            summary.vacBans <= 0 ? '' : `(${summary.daysSinceLastBan} days ago, ${summary.vacBans} total)`;
        badges.push(
            <Badge key="vac" variant="vac">
                VAC Ban{summary.vacBans > 1 ? 's' : ''}
            </Badge>
        );
        badges.push(<span className="text-sm text-rose-700">{banText}</span>);
    }
    return <div className="flex gap-1 flex-wrap">{badges}</div>;
}

export default BanStatusDisplay;
